<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    append-to-body
    width="550px"
    @close="close"
  >
    <div style="margin-bottom: 20px">该工单是否确认提交？</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="预约人员" prop="bookUserName">
        <el-input
          v-model.trim="form.bookUserName"
          type="text"
          autocomplete="off"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="兼职调查人员" prop="surveyUser">
        <el-select
          v-model="form.surveyUser"
          placeholder="请选择兼职调查人员"
          clearable
          filterable
        >
          <el-option
            v-for="item in investigateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小记" prop="note">
        <el-input
          v-model.trim="form.note"
          type="textarea"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="save">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getUsersListByRole,
    submit,
  } from "@/api/workplace/supervison/recommend";
  import { getRoleKey } from "@/utils/index";
  import { mapGetters } from "vuex";

  export default {
    name: "Submit",
    data() {
      return {
        loading: false,
        form: {
          bookUserName: "",
          bookUser: "",
          surveyUser: "",
          note: "",
        },
        rules: {
          bookUserName: [
            { required: true, trigger: "blur", message: "请选择预约人员" },
          ],
          surveyUser: [
            { required: true, trigger: "blur", message: "请选择调查人员" },
          ],
          note: [
            { required: true, message: "请输入小记", trigger: "blur" },
            {
              max: 500,
              message: "小记不能超过500个汉字",
              trigger: "blur",
            },
          ],
        },
        title: "",
        dialogFormVisible: false,
        investigateOptions: [],
        // 提交人员推荐参数
        parameter: {
          body: [],
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        obj: {
          console: "supervisor", // 固定写法
          note: null,
          operAction: "人员推荐", // 固定写法
          projectSource: "",
          step: "督导工作台-人员推荐-待处理", // 固定写法
          surveyUser: null,
          bookUser: null,
          userNo: "",
          userRoleNo: "",
          workOrderNo: null,
          procInsId: null,
          taskId: null,
        },
        param: {
          body: [
            {
              roleKey: "part_investigator",
            },
          ],
          header: {
            currentTime: "2020-09-09 12:12:12",
            requestId: "1",
            sourceType: "site",
          },
        },
        object: null,
      };
    },
    computed: {
      ...mapGetters({
        userNo: "user/userNo",
        roles: "user/roles",
      }),
    },
    created() {
      this.obj.userNo = this.userNo;
      this.obj.userRoleNo = getRoleKey("supervisor", this.roles);
    },
    methods: {
      async showSubmit(row) {
        this.title = "提交工单";
        this.dialogFormVisible = true;
        // 查询调查人员
        this.investigateOptions = (await getUsersListByRole(this.param)).body;
        this.form.bookUser = row[0].bookUser;
        this.form.bookUserName = row[0].bookUserName;

        for (let i = 0; i < this.investigateOptions.length; i++) {
          if (row[0].surveyUser === this.investigateOptions[i].value) {
            this.form.surveyUser = row[0].surveyUser;
            break;
          } else {
            this.form.surveyUser = "";
          }
        }

        this.object = row;

        this.parameter.body = [];
      },
      close() {
        this.$refs["form"].resetFields();
        this.form = this.$options.data().form;
        this.dialogFormVisible = false;
        // this.$emit("refreshData");
      },
      save() {
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.loading = true;
            for (let i = 0; i < this.object.length; i++) {
              this.obj.surveyUser = this.form.surveyUser;
              this.obj.note = this.form.note;
              this.obj.procInsId = this.object[i].procInsId;
              this.obj.taskId = this.object[i].taskId;
              this.obj.projectSource = this.object[i].source;
              this.obj.workOrderNo = this.object[i].workOrderNo;
              this.obj.userNo = this.object[i].monitorUser;
              this.obj.bookUser = this.object[i].bookUser;
              this.parameter.body.push(Object.assign({}, this.obj));
            }
            const { header } = await submit(this.parameter);
            if ("1" === header.retCode) {
              this.$baseMessage(header.retMessage, "success");
            } else {
              this.$baseMessage(header.retMessage, "error");
            }

            this.$refs["form"].resetFields();
            this.dialogFormVisible = false;
            this.$emit("refreshData");
            this.$emit("close");
            this.form = this.$options.data().form;
            this.loading = false;
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
<style scoped>
  .el-select,
  .el-cascader {
    width: 100%;
  }
</style>
